import i18next, { getFixedT } from 'i18next';
import LanguageDetector, { CustomDetector, DetectorOptions } from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enTranslation from './en.translations.json';
import esTranslation from './es.translations.json';

const languageDetector = new LanguageDetector();

const languageDetectorOptions: DetectorOptions = {
    lookupQuerystring: 'locale',
    order: ['customDetector', 'navigator', 'htmlTag'],
    caches: ['customDetector'],
};

const detector: CustomDetector = {
    name: 'customDetector',
    lookup() {
        return new URLSearchParams(window.location.search).get('locale') || undefined;
    },
    cacheUserLanguage(lng) {
        // Save as search params
        const url = new URL(window.location.href);
        url.searchParams.set('locale', lng);
        window.history.replaceState({}, '', url.href);

        // Change html lang attribute
        document.documentElement.lang = lng;

        // Change html title
        document.title = getFixedT(lng)('htmlTitle');
    },
};

languageDetector.addDetector(detector);

i18next
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'es'],
        detection: languageDetectorOptions,
        resources: {
            en: {
                translation: enTranslation,
            },
            es: {
                translation: esTranslation,
            },
        },
        interpolation: {
            escapeValue: false,
        },
    });
